// extracted by mini-css-extract-plugin
export default {"userCard":"card_userCard__NeGYn","userinfo":"card_userinfo__zXOht","options":"card_options__uWcQ6","deleteBtn":"card_deleteBtn__8-R6+","updateBtn":"card_updateBtn__i5zb2"};